// frontend/src/context/ToastContext.js
import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';
import { ToastContainer } from '../pages/Toast';

const ToastContext = createContext();

export const useToast = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 3000) => {
    console.log('🔔 Toast triggered:', { message, type, duration });
    const id = Date.now();
    setToasts(prevToasts => [...prevToasts, { id, message, type, duration }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
  }, []);

  const showConfirmationToast = useCallback((message, onConfirm, onCancel) => {
    const id = Date.now();
    setToasts(prevToasts => [
      ...prevToasts,
      {
        id,
        message,
        type: 'confirm',
        duration: 0,
        onConfirm: () => {
          removeToast(id);
          if (onConfirm) onConfirm();
        },
        onCancel: () => {
          removeToast(id);
          if (onCancel) onCancel();
        }
      }
    ]);
  }, [removeToast]);

  const contextValue = useMemo(() => ({ showToast, showConfirmationToast }), [showToast, showConfirmationToast]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
};